import { IconV1 } from 'common/icon/iconV1.js';
import {
  IWarningsPanelLoadedEmpty,
  IWarningsPanelLoadedSummary,
  IWarningsPanelLoadedWarnings,
  LoadedType,
} from './warning-panel-data.js';

interface HeaderLinkProps {
  warningState: IWarningsPanelLoadedSummary | IWarningsPanelLoadedWarnings | IWarningsPanelLoadedEmpty;
}

export const HeaderLinkText = ({ warningState }: HeaderLinkProps) => {
  if (warningState.hasWarnings && warningState.loadedType === LoadedType.REGIONAL) {
    return <IconV1 iconClass="warning-icon svg--fill-inherit" size={16} icon="chevron-down" />;
  }
  /** has no warnings or is of type national */
  return (
    <>
      View all&nbsp;<span className="u-sm-hidden">severe weather&nbsp;</span>
      <IconV1 iconClass="warning-icon svg--fill-inherit" size={16} icon="chevron-right" />
    </>
  );
};
